import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { firstValueFrom } from 'rxjs';
import { AddToProductComponent } from 'src/app/barcode/add-to-product/add-to-product.component';
import { setLoading } from 'src/app/redux/actions/user.actions';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { Product } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-barcodes',
  templateUrl: './barcodes.component.html',
  styleUrls: ['./barcodes.component.scss']
})
export class BarcodesComponent {
  @Input() set product(value: Product | undefined) {
    if (!value) return;
    this._product = value;
    if (value.barcodes) this.barcodes = value.barcodes;
  }

  get product() {
    return this._product;
  }

  private _product: Product | undefined;

  barcodes: Array<{
    id: number;
    barcode: string;
    shared_products?: Array<{ id: number; description: string; article: string; brand: string }>;
  }> = [];

  columnsToDisplay = ['barcode', 'menu'];

  constructor(
    private dialog: MatDialog,
    private store: Store<AppState>,
    private productService: ProductService,
    private notificationService: NotificationService
  ) {}

  set loading(value: boolean) {
    this.store.dispatch(setLoading({ payload: value }));
  }

  openBarcodeDialog() {
    if (!this._product) return;
    const dialogRef = this.dialog.open(AddToProductComponent);
    dialogRef.componentInstance.product = this._product;
    dialogRef.componentInstance.doneEvent.subscribe((list) => {
      if (list) {
        this.updateBarcodes(list);
        dialogRef.close();
      }
    });
  }

  updateBarcodes(list: typeof this.barcodes) {
    this.barcodes = list;
  }

  async deleteBarcode(barcode: string) {
    const confirm = window.confirm('Точно удалить?');
    if (!confirm) return;
    if (!this._product) return;
    this.loading = true;
    try {
      const res = await firstValueFrom(
        this.productService.removeBarcodeToProduct({
          product_id: this._product.id,
          barcode
        })
      );
      const newList = [...res];
      this.updateBarcodes(newList);
    } catch (err) {
      console.error(err);
    }
    this.loading = false;
    this.notificationService.notice(`Штрихкод ${barcode} удален`);
  }
}
